// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1161":"2daaf45d","2542":"862bd86a","4070":"2fafe83b","4850":"2fafe83b","5290":"9d9dcc9b"}[chunkId] + ".chunk.css";
};